import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { apiRequest, saveAuthData, API_ENDPOINTS, getCurrentUser } from '../api/config';
import '../styles/landing.css';
import LegalModal from '../components/LegalModal';

// Translations
const translations = {
  zh: {
    announce: '限时优惠：斗篷方案首月立减 40% · 三大平台全覆盖 · 5 分钟快速接入',
    heroBadge: '广告过审技术领导者',
    heroTitle: '三大平台广告',
    heroSubTitle: '一键安全过审',
    heroSub: '智能识别 TikTok Facebook Google 审核环境，自动切换合规内容，封号率降至 0，广告稳定投放。',
    ctaStart: '免费开始使用',
    ctaDemo: '▶  观看演示',
    ctaHint: '无需信用卡 · 5 分钟接入 · 随时取消',
    platforms: '支持平台',
    stat1: '广告过审率',
    stat2: '环境识别响应',
    stat3: '月服务广告主',
    stat4: '因封号产生损失',
    navFeatures: '产品功能',
    navPartners: '合作品牌',
    navPricing: '价格方案',
    navFaq: '常见问题',
    navDocs: '使用说明',
    login: '登录',
    freeTrial: '免费试用',
    partners: '已服务全球 5,000+ 广告主 · 覆盖主流出海行业',
    industry: ['金融理财', '游戏出海', '电商独立站', '交友社交', '工具 App', '短剧影视', '健康医疗'],
    casesTitle: '覆盖主流出海垂直赛道',
    casesDesc: '从游戏到金融，每个行业都有专属的斗篷过审解决方案',
    archTitle: '六层纵深防御引擎',
    archDesc: '自研多维信号融合算法，从网络层到应用层全链路识别，任何伪装流量无所遁形',
    archLayer1: '网络层信号采集',
    archLayer2: '应用层行为分析',
    archLayer3: '机器学习决策层',
    archMetrics: '覆盖 IP 段 2.3 亿+',
    featTitle: '针对每个平台的专属过审策略',
    featDesc: '深度解析三大平台审核机制，提供差异化保护方案，一套系统全覆盖。',
    featTabs: ['TikTok Ads', 'Facebook', 'Google'],
    howTitle: '4 步，让广告永远通过',
    howDesc: '从创建到过审，全流程自动化，无需人工干预',
    step1Title: '创建斗篷链接',
    step1Desc: '在平台一键生成专属斗篷 URL，替代原始落地页链接用于广告投放。',
    step1Time: '约 30 秒完成',
    step2Title: '智能流量识别',
    step2Desc: '系统实时分析每次访问的 IP、UA、行为特征，判断是否为平台审核流量。',
    step2Time: '响应 < 80ms',
    step3Title: '自动内容分发',
    step3Desc: '审核流量 → 合规展示页；真实用户 → 实际推广落地页。毫秒级切换，无感知。',
    step3Time: '全自动切换',
    step4Title: '广告稳定投放',
    step4Desc: '广告顺利过审，持续稳定曝光，账号安全零封禁，ROI 最大化。',
    step4Time: 'ROI 最大化',
    compareTitle: '使用前 vs 使用后',
    compare: [
      { label: '广告过审率', good: '99.3%，稳定过审', bad: '30~60%，随机被拒' },
      { label: '账号封禁风险', good: '接近零封号', bad: '高频封号，反复申诉' },
      { label: '人工审核拦截', good: '自动规避，无需担心', bad: '无法规避，束手无策' },
      { label: '敏感行业投放', good: '金融/PWA/App 全支持', bad: '大概率触发违规' },
      { label: '三平台统一管理', good: 'TikTok · FB · Google 一体化', bad: '各平台独立，成本倍增' },
      { label: '链接响应速度', good: '全球 CDN < 200ms', bad: '单节点，延迟不稳定' },
    ],
    faqTitle: '你可能想知道的 一切',
    faq: [
      { q: '斗篷技术合法吗？使用会有法律风险吗？', a: '斗篷技术本身是合法的流量分发技术，被广泛用于 A/B 测试、地域定向等场景。我们帮助广告主优化广告审核通过率，所有合规页面内容均由客户自行维护，平台最终展示内容的合规性由广告主负责。' },
      { q: '如何接入？技术难度高吗？', a: '接入非常简单，只需在我们平台创建一个斗篷链接，将其作为广告落地页 URL 填入即可。整个过程约 5 分钟，无需任何代码知识，我们提供图文教程和视频指导，遇到问题可随时联系客服。' },
      { q: '如果过审失败或账号被封，你们怎么处理？', a: '我们提供 14 天无理由退款保障。如果在使用期间因我们系统原因导致过审失败或账号被封，我们会优先排查问题并提供技术支持，情况属实会给予相应补偿。我们的过审率长期维持在 99.3% 以上。' },
      { q: '数据安全如何保障？你们会存储我的落地页内容吗？', a: '我们不存储您的落地页内容，仅记录访问日志用于流量识别。所有数据传输采用 HTTPS 加密，服务器部署在国际主流云服务商，定期安全审计。您的广告创意和落地页完全在您自己的服务器上。' },
      { q: '支持哪些行业？有行业限制吗？', a: '我们支持PWA、金融理财、游戏出海、电商、交友社交、工具 App、短剧影视、健康医疗等 8 大主流出海行业。唯一限制是您的最终落地页内容不得违反当地法律法规，否则我们有权拒绝服务。' },
      { q: '按访问次数计费怎么理解？次数会过期吗？', a: '套餐按真实链接访问次数计费，购买后次数即充入账户。套餐有效期内（90天或180天）未使用的次数将在到期后清零，请根据实际投放量选择合适套餐。次数充足时可随时升级更大套餐，差价补缴即可。' },
    ],
    pricingTitle: '按真实访问次数计费',
    pricingDesc: '按真实链接访问次数计费，购买即充入账户，按需使用无浪费。',
    plans: [
      { name: '体验版', price: '0', visits: '不限', perDay: '', valid: '长期有效', features: [['基础地理定向', true], ['UA 识别拦截', true], ['访问日志 1 天', true], ['最多 5 个斗篷', true], ['API 接入', false], ['子账号', false]] },
      { name: '入门版', price: '299', visits: '10,000', perDay: '$0.0299', valid: '90 天有效期', features: [['基础地理定向', true], ['UA 识别拦截', true], ['访问日志 30 天', true], ['最多 10 个斗篷', true], ['API 接入', false], ['子账号', false]] },
      { name: '成长版', price: '799', visits: '30,000', perDay: '$0.0266', valid: '90 天有效期', badge: '最热销', features: [['全球地理定向', true], ['UA 识别拦截', true], ['访问日志 90 天', true], ['最多 100 个斗篷', true], ['API 接入', true], ['子账号', false]] },
      { name: '专业版', price: '1,999', visits: '100,000', perDay: '$0.0200', valid: '180 天有效期', badge: '高性价比', features: [['全球地理定向', true], ['UA 识别拦截', true], ['访问日志 180 天', true], ['最多 300 个斗篷', true], ['API 接入', true], ['3 个子账号', true]] },
      { name: '旗舰版', price: '3,999', visits: '无限', perDay: '', valid: '365 天有效期', badge: '大团队', features: [['全球地理定向', true], ['UA 识别拦截', true], ['访问日志 365 天', true], ['无限斗篷数量', true], ['API 接入', true], ['10 个子账号', true]] },
    ],
    buyNow: '立即购买',
    trust: ['SSL 全程加密', '14 天无理由退款', '无需信用卡试用', '全球 CDN 加速', '5000+ 客户信赖'],
    ctaTitle: '准备好让广告永远通过了吗？',
    ctaDesc: '立即免费试用，无需信用卡，5 分钟完成接入。',
    ctaAction: '立即开始使用',
    ctaSales: '💬 联系商务顾问',
    footer: '© 2025 MagicAudit. All rights reserved.',
    footerLinks: ['隐私政策', '服务条款', '帮助中心', '联系我们'],
    loginTitle: '登录',
    registerTitle: '注册',
    email: '邮箱地址',
    password: '密码',
    forgotPassword: '忘记密码？',
    noAccount: '还没有账号？',
    haveAccount: '已有账号？',
    agreeTerms: '我已阅读并同意 服务条款 和 隐私政策',
    sending: '验证码已发送，请查收邮箱。',
    loginSuccess: '✓ 登录成功！',
    regSuccess: '✓ 注册成功！请登录。',
    floatBar: (
      <>
        <strong>🛡 奇迹妙审</strong>
        &nbsp;— 广告过审率 99.3%，现在免费试用
      </>
    ),
    salesTitle: '联系我们的精英商务团队',
    salesDesc: '选择下方任一VIP专属通道，立即获得优先响应',
  },
  en: {
    announce: 'Limited offer: 40% off first month · All 3 platforms covered · 5-min quick setup',
    heroBadge: 'Ad Review Technology Leader',
    heroTitle: 'Multi-Platform Ads',
    heroSubTitle: 'Pass Reviews Every Time',
    heroSub: 'Intelligent detection of TikTok Facebook Google review environments, auto-switch compliant content, zero bans, stable ad delivery.',
    ctaStart: 'Start for Free',
    ctaDemo: '▶  Watch Demo',
    ctaHint: 'No credit card · 5-min setup · Cancel anytime',
    platforms: 'Platforms',
    stat1: 'Approval Rate',
    stat2: 'Detection Response',
    stat3: 'Monthly Advertisers',
    stat4: 'Ban-Related Losses',
    navFeatures: 'Features',
    navPartners: 'Partners',
    navPricing: 'Pricing',
    navFaq: 'FAQ',
    navDocs: 'Docs',
    login: 'Login',
    freeTrial: 'Free Trial',
    partners: 'Serving 5,000+ advertisers worldwide · All major industries covered',
    industry: ['Fintech', 'Mobile Gaming', 'E-Commerce', 'Social Dating', 'Utility App', 'Short Drama', 'Healthcare'],
    casesTitle: 'Covering Major Overseas Verticals',
    casesDesc: 'From gaming to fintech, every industry has a dedicated cloaking solution',
    archTitle: 'Six-Layer Deep Defense Engine',
    archDesc: 'Proprietary multi-signal fusion algorithm, full-chain detection from network to application layer',
    archLayer1: 'Network Layer Signals',
    archLayer2: 'App Layer Behavior Analysis',
    archLayer3: 'ML Decision Layer',
    archMetrics: '230M+ IP ranges covered',
    featTitle: 'Platform-Specific Review Strategies',
    featDesc: 'Deep analysis of all 3 platform review systems, differential protection in one unified system.',
    featTabs: ['TikTok Ads', 'Facebook', 'Google'],
    howTitle: '4 Steps to Perfect Approval',
    howDesc: 'From creation to approval, fully automated — no manual intervention needed',
    step1Title: 'Create a Cloak Link',
    step1Desc: 'Generate a dedicated cloaking URL in one click, then use it as your ad landing page URL.',
    step1Time: 'Done in ~30 seconds',
    step2Title: 'Intelligent Traffic Detection',
    step2Desc: 'The system analyzes each visit IP, UA, and behavioral signals in real time to detect review traffic.',
    step2Time: 'Response < 80ms',
    step3Title: 'Automatic Content Routing',
    step3Desc: 'Review traffic → compliance page; real users → your promo landing page. Millisecond switching.',
    step3Time: 'Fully Automated',
    step4Title: 'Stable Ad Delivery',
    step4Desc: 'Ads pass review, deliver stable impressions, zero account bans, maximum ROI.',
    step4Time: 'Maximize ROI',
    compareTitle: 'Without vs With MagicAudit',
    compare: [
      { label: 'Ad Approval Rate', good: '99.3%, stable approval', bad: '30–60%, randomly rejected' },
      { label: 'Account Ban Risk', good: 'Near-zero bans', bad: 'Frequent bans, constant appeals' },
      { label: 'Manual Review Bypass', good: 'Auto-bypass, zero worry', bad: 'No bypass capability' },
      { label: 'Sensitive Industry Ads', good: 'Finance / Gaming / Apps supported', bad: 'High probability of violations' },
      { label: 'Multi-Platform Management', good: 'TikTok · FB · Google unified', bad: 'Each platform separate, costs multiply' },
      { label: 'Link Response Speed', good: 'Global CDN < 200ms', bad: 'Single node, unstable latency' },
    ],
    faqTitle: 'Everything You Need to Know',
    faq: [
      { q: 'Is cloaking technology legal? Are there legal risks?', a: 'Cloaking is a legal traffic distribution technique widely used for A/B testing and geo-targeting. We help advertisers optimize ad review rates. Compliance page content is maintained by the client.' },
      { q: 'How do I integrate? Is it technically complex?', a: 'Integration is very simple. Just create a cloaking link on our platform and use it as your ad landing page URL. The whole process takes about 5 minutes with no coding required.' },
      { q: 'What happens if a review fails or my account gets banned?', a: 'We offer a 14-day no-questions-asked refund. If a review failure or ban occurs due to our system, we will investigate and provide technical support first.' },
      { q: 'How is data security guaranteed? Do you store my landing page content?', a: 'We do not store your landing page content. We only record access logs for traffic analysis. All data is HTTPS-encrypted with regular security audits.' },
      { q: 'What industries are supported? Are there restrictions?', a: 'We support 8 major overseas industries: gambling, fintech, mobile gaming, e-commerce, social dating, utility apps, short drama, and healthcare.' },
      { q: 'How does pay-per-visit work? Do visits expire?', a: 'Plans are billed by actual link visits. Purchased visits are credited to your account immediately. Unused visits expire at the end of the validity period.' },
    ],
    pricingTitle: 'Pay Per Real Visit',
    pricingDesc: 'Billed by real link visits. Credits are added to your account instantly — use exactly what you need.',
    plans: [
      { name: 'Trial', price: '0', visits: 'Unlimited', perDay: '', valid: 'Long-term', features: [['Basic Geo-Targeting', true], ['UA Detection & Block', true], ['Access Logs 1 day', true], ['Up to 5 Cloaks', true], ['API Access', false], ['Sub-accounts', false]] },
      { name: 'Starter', price: '299', visits: '10,000', perDay: '$0.0299', valid: 'Valid 90 days', features: [['Basic Geo-Targeting', true], ['UA Detection & Block', true], ['Access Logs 30 days', true], ['Up to 10 Cloaks', true], ['API Access', false], ['Sub-accounts', false]] },
      { name: 'Growth', price: '799', visits: '30,000', perDay: '$0.0266', valid: 'Valid 90 days', badge: 'Best Seller', features: [['Global Geo-Targeting', true], ['UA Detection & Block', true], ['Access Logs 90 days', true], ['Up to 50 Cloaks', true], ['API Access', true], ['Sub-accounts', false]] },
      { name: 'Pro', price: '1,999', visits: '100,000', perDay: '$0.0200', valid: 'Valid 180 days', badge: 'Best Value', features: [['Global Geo-Targeting', true], ['UA Detection & Block', true], ['Access Logs 180 days', true], ['Up to 50 Cloaks', true], ['API Access', true], ['3 Sub-accounts', true]] },
      { name: 'Enterprise', price: '3,999', visits: 'Unlimited', perDay: '', valid: 'Valid 365 days', badge: 'For Teams', features: [['Global Geo-Targeting', true], ['UA Detection & Block', true], ['Access Logs 365 days', true], ['Unlimited Cloaks', true], ['API Access', true], ['10 Sub-accounts', true]] },
    ],
    buyNow: 'Buy Now',
    trust: ['SSL Encrypted', '14-Day Refund', 'No Credit Card', 'Global CDN', '5000+ Trusted'],
    ctaTitle: 'Ready to make your ads pass review every time?',
    ctaDesc: 'Start your free trial now — no credit card, setup in 5 minutes.',
    ctaAction: 'Get Started Now',
    ctaSales: '💬 Contact Sales',
    footer: '© 2025 MagicAudit. All rights reserved.',
    footerLinks: ['Privacy Policy', 'Terms of Service', 'Help Center', 'Contact Us'],
    loginTitle: 'Login',
    registerTitle: 'Register',
    email: 'Email Address',
    password: 'Password',
    forgotPassword: 'Forgot password?',
    noAccount: "Don't have an account?",
    haveAccount: 'Already have an account?',
    agreeTerms: 'I agree to the Terms of Service and Privacy Policy',
    sending: 'Code sent! Check your inbox.',
    loginSuccess: '✓ Login successful!',
    regSuccess: '✓ Account created! Please login.',
    floatBar: (
      <>
        <strong>🛡 MagicAudit</strong>
        &nbsp;— 99.3% Ad Approval Rate, Try Free Now
      </>
    ),
    salesTitle: 'Contact Our Elite Sales Team',
    salesDesc: 'Choose any VIP channel below for priority response',
  },
};

// Phone mockup data (使用本地图片)
const phoneApps = [
  { type: 'gaming', img: '/images/gaming1.jpg', labelKey: 'Mobile Gaming' },
  { type: 'gaming2', img: '/images/gaming2.jpg', labelKey: 'Mobile Gaming' },
  { type: 'fintech', img: '/images/fintech.jpg', labelKey: 'Fintech' },
  { type: 'shortdrama', img: '/images/shortdrama.jpg', labelKey: 'Short Drama' },
  { type: 'dating', img: '/images/dating.jpg', labelKey: 'Social Dating' },
];

// Social proof popups
const socialPopups = [
  { email: 'zh***g@gmail.com', zh: '刚刚注册了专业版', en: 'just signed up for Pro' },
  { email: 'le***w@outlook.com', zh: '开始了免费试用', en: 'started a free trial' },
  { email: 'wa***g@163.com', zh: '升级到了企业版', en: 'upgraded to Business' },
  { email: 'mi***l@hotmail.com', zh: '刚刚注册了专业版', en: 'just signed up for Pro' },
  { email: 'li***n@qq.com', zh: '开始了免费试用', en: 'started a free trial' },
];

const avatarColors = [
  'linear-gradient(135deg,#7C3AED,#EC4899)',
  'linear-gradient(135deg,#059669,#3B82F6)',
  'linear-gradient(135deg,#F59E0B,#EF4444)',
  'linear-gradient(135deg,#0EA5E9,#8B5CF6)',
  'linear-gradient(135deg,#EC4899,#F59E0B)',
];

// Animated Counter Component
const AnimatedCounter = ({ target, suffix = '', prefix = '' }) => {
  const [value, setValue] = useState('0');
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          const numericTarget = parseFloat(target);
          const duration = 1800;
          const start = performance.now();
          const isDecimal = numericTarget < 100;

          const animate = (now) => {
            const progress = Math.min((now - start) / duration, 1);
            const ease = 1 - Math.pow(1 - progress, 3);
            const val = numericTarget * ease;

            if (numericTarget >= 1000) {
              setValue(Math.floor(val).toLocaleString() + suffix);
            } else if (isDecimal && numericTarget < 1) {
              setValue(val.toFixed(2) + suffix);
            } else if (isDecimal) {
              setValue(val.toFixed(1) + suffix);
            } else {
              setValue(Math.floor(val) + suffix);
            }

            if (progress < 1) requestAnimationFrame(animate);
          };

          requestAnimationFrame(animate);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.5 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [target, suffix]);

  return <span ref={ref}>{prefix}{value}</span>;
};

// Reveal on Scroll Component
const RevealWrapper = ({ children, className = '', delay = '' }) => {
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.12 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className={`reveal ${delay} ${className}`}>
      {children}
    </div>
  );
};

// Navigation Component
const Navigation = ({ lang, onOpenAuth, onToggleLang }) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const t = translations[lang];

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 检查登录状态
  useEffect(() => {
    const checkAuth = () => {
      try {
        const authDataStr = localStorage.getItem('authData');
        if (authDataStr) {
          const authData = JSON.parse(authDataStr);
          if (authData.token && authData.user && authData.user.email) {
            setCurrentUser(authData.user);
            return;
          }
        }
        setCurrentUser(null);
      } catch (e) {
        setCurrentUser(null);
      }
    };
    checkAuth();
    window.addEventListener('authStateChanged', checkAuth);
    return () => window.removeEventListener('authStateChanged', checkAuth);
  }, []);

  // 生成用户头像初始字母
  const getUserInitials = (email) => {
    if (!email) return '?';
    const username = email.split('@')[0];
    if (username.includes('.') || username.includes('_')) {
      const parts = username.split(/[._]/);
      return parts.map(part => part[0]?.toUpperCase() || '').join('').substring(0, 2);
    }
    return username.substring(0, 2).toUpperCase();
  };

  // 导航到斗篷管理
  const goToDashboard = () => {
    if (currentUser && (currentUser.role === 'admin' || currentUser.role === 'superadmin')) {
      window.location.href = '/dashboard/admin/dashboard';
    } else {
      window.location.href = '/dashboard';
    }
  };

  const navItems = [
    { href: '#features', label: t.navFeatures },
    { href: '#partners', label: t.navPartners },
    { href: '#pricing', label: t.navPricing },
    { href: '#faq', label: t.navFaq },
    { href: '#', label: t.navDocs },
  ];

  return (
    <>
      <nav className={scrolled ? 'scrolled' : ''}>
        <a href="#" className="logo">
          <img src="/logo.png" alt="MagicAudit" style={{ width: '32px', height: '32px' }} />
          <span>{lang === 'zh' ? '奇迹妙审' : 'MagicAudit'}</span>
        </a>
        <ul className="nav-links">
          {navItems.map((item) => (
            <li key={item.href}><a href={item.href}>{item.label}</a></li>
          ))}
        </ul>
        <div className="nav-r">
          <button className="btn-lang" onClick={onToggleLang}>
            {lang === 'zh' ? 'EN' : '中文'}
          </button>
          {!currentUser ? (
            <>
              <button className="btn-ghost" onClick={() => onOpenAuth('login')}>{t.login}</button>
              <button className="btn-primary" onClick={() => onOpenAuth('register')}>{t.freeTrial}</button>
            </>
          ) : (
            <>
              <button className="btn-primary" onClick={goToDashboard}>
                {lang === 'zh' ? '斗篷管理' : 'Dashboard'}
              </button>
              <div className="user-avatar" onClick={goToDashboard} title={currentUser.email}>
                {getUserInitials(currentUser.email)}
              </div>
            </>
          )}
          <button
            className="nav-toggle"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <span></span><span></span><span></span>
          </button>
        </div>
      </nav>
      {mobileOpen && (
        <div className="nav-drawer">
          {navItems.map((item) => (
            <a key={item.href} href={item.href} onClick={() => setMobileOpen(false)}>
              {item.label}
            </a>
          ))}
          <div className="nav-drawer-btns">
            {!currentUser ? (
              <>
                <button className="btn-ghost" onClick={() => { onOpenAuth('login'); setMobileOpen(false); }}>
                  {t.login}
                </button>
                <button className="btn-primary" onClick={() => { onOpenAuth('register'); setMobileOpen(false); }}>
                  {t.freeTrial}
                </button>
              </>
            ) : (
              <button className="btn-primary" onClick={() => { goToDashboard(); setMobileOpen(false); }}>
                {lang === 'zh' ? '斗篷管理' : 'Dashboard'}
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};

// Hero Section
const Hero = ({ lang, onOpenAuth, currentUser, goToDashboard }) => {
  const t = translations[lang];
  const stats = [
    { value: '99.3', suffix: '%', label: t.stat1 },
    { value: '0.08', suffix: 's', label: t.stat2 },
    { value: '5000', suffix: '+', label: t.stat3 },
    { value: '0', prefix: '$', suffix: '', label: t.stat4 },
  ];

  return (
    <section className="hero">
      <div className="hero-grid"></div>
      <div className="hero-vignette"></div>

      <RevealWrapper>
        <div className="eyebrow">
          <span className="eyebrow-dot"></span>
          {t.heroBadge}
        </div>
      </RevealWrapper>

      <RevealWrapper delay="reveal-delay-1">
        <h1>
          <span className="h1-plain">{t.heroTitle}</span>
          <span className="h1-grad">{t.heroSubTitle}</span>
        </h1>
      </RevealWrapper>

      <RevealWrapper delay="reveal-delay-2">
        <p className="hero-sub">
          {t.heroSub}
        </p>
      </RevealWrapper>

      <RevealWrapper delay="reveal-delay-3">
        <div className="cta-group">
          <button className="btn-hero btn-hero-p" onClick={() => currentUser ? goToDashboard() : onOpenAuth('register')}>
            {t.ctaStart}
          </button>
          <button className="btn-hero btn-hero-g">
            {t.ctaDemo}
          </button>
        </div>
        <p className="cta-hint">{t.ctaHint}</p>
      </RevealWrapper>

      <RevealWrapper delay="reveal-delay-4">
        <div className="plat-row">
          <span className="plat-label">{t.platforms}</span>
          <div className="plat-chip"><span className="chip-dot cd-tt"></span>TikTok Ads</div>
          <div className="plat-chip"><span className="chip-dot cd-fb"></span>Meta / Facebook</div>
          <div className="plat-chip"><span className="chip-dot cd-gg"></span>Google Ads</div>
        </div>

        <div className="stats-row">
          {stats.map((stat, i) => (
            <div className="stat" key={i}>
              <div className="stat-n">
                <AnimatedCounter target={stat.value} suffix={stat.suffix} />
              </div>
              <div className="stat-l">{stat.label}</div>
            </div>
          ))}
        </div>
      </RevealWrapper>
    </section>
  );
};

// Partners Section
const Partners = ({ lang }) => {
  const t = translations[lang];
  const industries = [
    { color: '#3B82F6', label: t.industry[0] },
    { color: '#10B981', label: t.industry[1] },
    { color: '#F59E0B', label: t.industry[2] },
    { color: '#EC4899', label: t.industry[3] },
    { color: '#8B5CF6', label: t.industry[4] },
    { color: '#06B6D4', label: t.industry[5] },
    { color: '#EF4444', label: t.industry[6] },
  ];

  return (
    <section className="partners-bg" id="partners">
      <RevealWrapper>
        <p className="partners-label">{t.partners}</p>
      </RevealWrapper>
      <RevealWrapper delay="reveal-delay-1">
        <div className="partners-track">
          {industries.map((ind, i) => (
            <div className="partner-chip" key={i}>
              <span className="pc-dot" style={{ background: ind.color }}></span>
              {ind.label}
            </div>
          ))}
        </div>
      </RevealWrapper>
    </section>
  );
};

// Phone Carousel
const PhoneCarousel = ({ lang }) => {
  const trackRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);
  const t = translations[lang];

  useEffect(() => {
    let x = 0;
    let animationId;
    const phones = phoneApps.length;

    const animate = () => {
      if (!isPaused) {
        x -= 0.7;
        if (trackRef.current) {
          const halfWidth = phones * (158 + 28) + 100;
          if (x <= -halfWidth) x += halfWidth;
          trackRef.current.style.transform = `translateX(${x}px)`;
        }
      }
      animationId = requestAnimationFrame(animate);
    };

    animationId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationId);
  }, [isPaused]);

  const labelMap = {
    'Mobile Gaming': lang === 'zh' ? '游戏出海' : 'Mobile Gaming',
    'Fintech': lang === 'zh' ? '金融理财' : 'Fintech',
    'Short Drama': lang === 'zh' ? '短剧影视' : 'Short Drama',
    'Social Dating': lang === 'zh' ? '交友社交' : 'Social Dating',
  };

  return (
    <section className="cases-bg">
      <div className="cases-title">
        <RevealWrapper>
          <div className="tag">{lang === 'zh' ? '行业案例' : 'Industry Cases'}</div>
          <h2 className="s-title">
            <span>{t.casesTitle}</span>
          </h2>
          <p className="s-desc" style={{ margin: '0 auto' }}>{t.casesDesc}</p>
        </RevealWrapper>
      </div>
      <div className="carousel-mask">
        <div
          className="carousel-track"
          ref={trackRef}
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          {[...phoneApps, ...phoneApps].map((app, i) => (
            <div className="phone-wrap" key={i}>
              <div className="phone-frame">
                <div className="phone-notch"></div>
                <div className="phone-screen" style={{ height: '290px', display: 'block' }}>
                  <img
                    src={app.img}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                    loading="lazy"
                    alt={app.labelKey}
                  />
                </div>
              </div>
              <span className="phone-label">{labelMap[app.labelKey]}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// Architecture Section
const Architecture = ({ lang }) => {
  const t = translations[lang];
  const pipeline = [
    { icon: '🌐', label: lang === 'zh' ? '访问请求' : 'Request', sub: 'HTTP/2 · HTTPS', type: 'entry' },
    { icon: '🔬', label: lang === 'zh' ? 'TLS 指纹' : 'TLS Fingerprint', sub: 'JA3 / JA3S' },
    { icon: '📡', label: lang === 'zh' ? 'ASN 溯源' : 'ASN Lookup', sub: 'BGP · WHOIS' },
    { icon: '🧠', label: lang === 'zh' ? '行为建模' : 'Behavior Model', sub: 'ML Inference' },
    { icon: '⚖️', label: lang === 'zh' ? '决策引擎' : 'Decision Engine', sub: '< 8ms P99' },
    { icon: '🎯', label: lang === 'zh' ? '内容路由' : 'Content Router', sub: 'Dynamic CDN', type: 'end' },
  ];

  const infra = [
    { val: '42', key: lang === 'zh' ? '全球 PoP 节点' : 'Global PoP Nodes' },
    { val: '99.99%', key: lang === 'zh' ? 'SLA 可用性承诺' : 'SLA Uptime' },
    { val: '1.2M+', key: lang === 'zh' ? 'JA3 指纹库条目' : 'JA3 DB Entries' },
    { val: '< 8ms', key: lang === 'zh' ? '决策引擎 P99 延迟' : 'Decision P99 Latency' },
    { val: '24h', key: lang === 'zh' ? '黑名单自动更新周期' : 'Blocklist Update Cycle' },
  ];

  return (
    <section className="arch-bg" id="architecture">
      <div className="arch-inner">
        <RevealWrapper>
          <div style={{ textAlign: 'center', marginBottom: '56px' }}>
            <div className="tag">{lang === 'zh' ? '技术架构' : 'Tech Architecture'}</div>
            <h2 className="s-title">
              <span>{t.archTitle}</span>
            </h2>
            <p className="s-desc" style={{ margin: '0 auto' }}>{t.archDesc}</p>
          </div>
        </RevealWrapper>

        <RevealWrapper delay="reveal-delay-1">
          <div className="pipeline">
            {pipeline.map((node, i) => (
              <React.Fragment key={i}>
                <div className={`pipe-node ${node.type || ''}`}>
                  <div className="pipe-icon">{node.icon}</div>
                  <div className="pipe-label">{node.label}</div>
                  <div className="pipe-sub">{node.sub}</div>
                </div>
                {i < pipeline.length - 1 && <span className="pipe-arrow">→</span>}
              </React.Fragment>
            ))}
          </div>
        </RevealWrapper>

        <RevealWrapper delay="reveal-delay-2">
          <div className="arch-grid">
            <div className="arch-card gcard">
              <div className="arch-card-head">
                <span className="arch-badge" style={{ background: 'rgba(103,232,249,.1)', borderColor: 'rgba(103,232,249,.25)', color: 'var(--cyan)' }}>Layer 1–2</span>
                <span className="arch-card-title">{t.archLayer1}</span>
              </div>
              <ul className="arch-list">
                <li><span className="arch-dot" style={{ background: '#67E8F9' }}></span>{lang === 'zh' ? 'TLS ClientHello 指纹比对（JA3 Hash 库 120万+ 条目）' : 'TLS ClientHello fingerprint matching (1.2M+ entry JA3 Hash DB)'}</li>
                <li><span className="arch-dot" style={{ background: '#67E8F9' }}></span>{lang === 'zh' ? 'BGP ASN 归属解析，精准定位数据中心 IP 段' : 'BGP ASN attribution to precisely identify datacenter IP ranges'}</li>
                <li><span className="arch-dot" style={{ background: '#67E8F9' }}></span>{lang === 'zh' ? 'TCP/IP 协议栈特征提取（TTL、Window Size、选项顺序）' : 'TCP/IP stack fingerprinting (TTL, Window Size, option order)'}</li>
                <li><span className="arch-dot" style={{ background: '#67E8F9' }}></span>{lang === 'zh' ? 'IPv6 隧道封装检测，规避 GRE/IPIP 伪装' : 'IPv6 tunnel detection, defeating GRE/IPIP obfuscation'}</li>
              </ul>
              <div className="arch-metric">{t.archMetrics}</div>
            </div>

            <div className="arch-card gcard">
              <div className="arch-card-head">
                <span className="arch-badge" style={{ background: 'rgba(139,92,246,.1)', borderColor: 'rgba(139,92,246,.3)', color: 'var(--p3)' }}>Layer 3–4</span>
                <span className="arch-card-title">{t.archLayer2}</span>
              </div>
              <ul className="arch-list">
                <li><span className="arch-dot" style={{ background: '#A78BFF' }}></span>{lang === 'zh' ? 'HTTP/2 HPACK 头部压缩顺序指纹识别' : 'HTTP/2 HPACK header compression order fingerprinting'}</li>
                <li><span className="arch-dot" style={{ background: '#A78BFF' }}></span>{lang === 'zh' ? 'User-Agent 熵值分析 + 浏览器特征矩阵交叉验证' : 'User-Agent entropy analysis + browser fingerprint matrix cross-validation'}</li>
                <li><span className="arch-dot" style={{ background: '#A78BFF' }}></span>{lang === 'zh' ? 'Cookie / Storage 存在性探测，识别无状态爬虫' : 'Cookie/Storage presence detection to identify stateless crawlers'}</li>
                <li><span className="arch-dot" style={{ background: '#A78BFF' }}></span>{lang === 'zh' ? 'Referer 链路追踪，还原完整访问上下文' : 'Referer chain tracking to reconstruct the full visit context'}</li>
              </ul>
              <div className="arch-metric">{lang === 'zh' ? '特征维度 47 项 实时融合' : '47 feature dimensions fused in real time'}</div>
            </div>

            <div className="arch-card gcard">
              <div className="arch-card-head">
                <span className="arch-badge" style={{ background: 'rgba(16,185,129,.1)', borderColor: 'rgba(16,185,129,.3)', color: '#10B981' }}>Layer 5–6</span>
                <span className="arch-card-title">{t.archLayer3}</span>
              </div>
              <ul className="arch-list">
                <li><span className="arch-dot" style={{ background: '#10B981' }}></span>{lang === 'zh' ? 'GBM + Transformer 双模型 Ensemble 投票机制' : 'GBM + Transformer dual-model Ensemble voting'}</li>
                <li><span className="arch-dot" style={{ background: '#10B981' }}></span>{lang === 'zh' ? '在线学习管道，24h 自动吸收新审核 IP 特征' : 'Online learning pipeline, auto-ingests new review IP patterns every 24h'}</li>
                <li><span className="arch-dot" style={{ background: '#10B981' }}></span>{lang === 'zh' ? '置信度阈值动态调节，P99 延迟锁定 < 8ms' : 'Dynamic confidence thresholds, P99 latency locked at < 8ms'}</li>
                <li><span className="arch-dot" style={{ background: '#10B981' }}></span>{lang === 'zh' ? '灰度决策沙盒，模型上线前 A/B 回归验证' : 'Canary decision sandbox with A/B regression before deployment'}</li>
              </ul>
              <div className="arch-metric">{lang === 'zh' ? '模型推理延迟 P99 < 8ms' : 'Inference latency P99 < 8ms'}</div>
            </div>
          </div>
        </RevealWrapper>

        <RevealWrapper delay="reveal-delay-3">
          <div className="infra-row">
            {infra.map((item, i) => (
              <React.Fragment key={i}>
                <div className="infra-item">
                  <div className="infra-val">{item.val}</div>
                  <div className="infra-key">{item.key}</div>
                </div>
                {i < infra.length - 1 && <div className="infra-sep"></div>}
              </React.Fragment>
            ))}
          </div>
        </RevealWrapper>
      </div>
    </section>
  );
};

// Features Section
const Features = ({ lang }) => {
  const t = translations[lang];
  const [activeTab, setActiveTab] = useState(0);

  const features = [
    {
      icon: '🔬',
      title: lang === 'zh' ? '多维流量指纹识别引擎' : 'Multi-Dimensional Traffic Fingerprinting',
      desc: lang === 'zh' ? '同步采集 TLS JA3 哈希、HTTP/2 帧顺序、TCP 窗口大小、UA 熵值等 47 项特征，GBM + Transformer 双模型 Ensemble 实时推理，毫秒级判定是否为平台审核机器人。' : 'Simultaneously collects TLS JA3 hash, HTTP/2 frame order, TCP window size, UA entropy and 47 other features.',
      metrics: [lang === 'zh' ? '准确率 99.7%' : '99.7% Accuracy', lang === 'zh' ? '47 项特征融合' : '47-Feature Fusion'],
    },
    {
      icon: '⚡',
      title: lang === 'zh' ? '边缘节点实时内容路由' : 'Edge Node Real-Time Content Routing',
      desc: lang === 'zh' ? '决策结果通过 Anycast 路由下发至距用户最近的 PoP 节点，利用 HTTP/2 Server Push 预加载目标落地页，审核流量回传合规页，真实流量直传推广页，全程零主域名暴露。' : 'Decisions are pushed via Anycast to the nearest PoP node, using HTTP/2 Server Push to preload the target landing page.',
      metrics: [lang === 'zh' ? '切换 < 80ms' : 'Switch < 80ms', lang === 'zh' ? '42 个 PoP 节点' : '42 PoP Nodes'],
    },
    {
      icon: '🗄️',
      title: lang === 'zh' ? 'CIDR 聚合黑名单数据库' : 'CIDR-Aggregated Blocklist Database',
      desc: lang === 'zh' ? '基于 BGP 路由表 + ASN 归属映射构建的审核 IP 知识图谱，对 200+ 数据中心 CIDR 段进行子网聚合，通过 RPKI 验证消除欺骗性宣告，每 24h 全量差分同步至所有边缘节点。' : 'IP knowledge graph built on BGP routing tables + ASN mappings covers 200+ datacenter CIDRs with RPKI-verified subnet aggregation.',
      metrics: [lang === 'zh' ? '2.3亿+ IP 覆盖' : '230M+ IPs Covered', lang === 'zh' ? '每日自动同步' : 'Daily Auto-Sync'],
    },
    {
      icon: '🛡️',
      title: lang === 'zh' ? '零信任链路加密传输' : 'Zero-Trust Encrypted Transmission',
      desc: lang === 'zh' ? '全链路 TLS 1.3 + HSTS Preload，支持 ESNI（Encrypted SNI）防止中间人嗅探目标域名。CDN 回源采用 mTLS 双向认证，Origin IP 在公网零暴露，彻底封堵旁路溯源攻击。' : 'Full-chain TLS 1.3 + HSTS Preload with ESNI support to prevent SNI sniffing. CDN origin uses mTLS mutual auth.',
      metrics: [lang === 'zh' ? 'TLS 1.3 全程' : 'TLS 1.3 End-to-End', lang === 'zh' ? 'TTFB < 200ms' : 'TTFB < 200ms'],
    },
  ];

  const tabColors = ['#00F2EA', '#1877F2', '#34A853'];

  return (
    <section className="feat-bg" id="features">
      <div className="feat-inner">
        <RevealWrapper>
          <div style={{ marginBottom: '42px' }}>
            <div className="tag">{lang === 'zh' ? '核心功能' : 'Core Features'}</div>
            <h2 className="s-title">
              <span>{t.featTitle}</span>
            </h2>
            <p className="s-desc">{t.featDesc}</p>
          </div>
        </RevealWrapper>

        <RevealWrapper delay="reveal-delay-1">
          <div className="tab-bar">
            {t.featTabs.map((tab, i) => (
              <button
                key={i}
                className={`tab ${activeTab === i ? 'on' : ''}`}
                onClick={() => setActiveTab(i)}
              >
                <span className="tdot" style={{ background: tabColors[i] }}></span>
                {tab}
              </button>
            ))}
          </div>
        </RevealWrapper>

        <div className="feat-grid">
          {features.map((feat, i) => (
            <RevealWrapper key={i} delay={`reveal-delay-${(i % 4) + 1}`}>
              <div className="feat-card gcard">
                <div className="feat-icon">{feat.icon}</div>
                <h4>{feat.title}</h4>
                <p>{feat.desc}</p>
                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginTop: '4px' }}>
                  {feat.metrics.map((m, j) => (
                    <span key={j} className="metric">✦ {m}</span>
                  ))}
                </div>
              </div>
            </RevealWrapper>
          ))}
        </div>
      </div>
    </section>
  );
};

// How It Works Section
const HowItWorks = ({ lang }) => {
  const t = translations[lang];
  const steps = [
    { title: t.step1Title, desc: t.step1Desc, time: t.step1Time, num: '01' },
    { title: t.step2Title, desc: t.step2Desc, time: t.step2Time, num: '02' },
    { title: t.step3Title, desc: t.step3Desc, time: t.step3Time, num: '03' },
    { title: t.step4Title, desc: t.step4Desc, time: t.step4Time, num: '04' },
  ];

  return (
    <section className="how-bg">
      <div className="how-inner">
        <RevealWrapper>
          <div style={{ textAlign: 'center', marginBottom: '52px' }}>
            <div className="tag">{lang === 'zh' ? '工作原理' : 'How It Works'}</div>
            <h2 className="s-title">
              <span>{t.howTitle}</span>
            </h2>
            <p className="s-desc" style={{ margin: '0 auto' }}>{t.howDesc}</p>
          </div>
        </RevealWrapper>

        <div className="steps">
          {steps.map((step, i) => (
            <RevealWrapper key={i} delay={`reveal-delay-${i + 1}`}>
              <div className="step gcard">
                <div className="step-bg-n">{step.num}</div>
                <div className="step-n">{i + 1}</div>
                <h4>{step.title}</h4>
                <p>{step.desc}</p>
                <div className="step-time">{step.time}</div>
                {i < steps.length - 1 && <span className="step-arr">›</span>}
              </div>
            </RevealWrapper>
          ))}
        </div>
      </div>
    </section>
  );
};

// Compare Section
const Compare = ({ lang }) => {
  const t = translations[lang];

  return (
    <section className="cmp-bg">
      <div className="cmp-inner">
        <RevealWrapper>
          <div style={{ textAlign: 'center', marginBottom: '46px' }}>
            <div className="tag">{lang === 'zh' ? '效果对比' : 'Before vs After'}</div>
            <h2 className="s-title">
              <span>{t.compareTitle}</span>
            </h2>
          </div>
        </RevealWrapper>

        <RevealWrapper delay="reveal-delay-1">
          <div className="cmp-wrap">
            <table className="cmp-table">
              <thead>
                <tr>
                  <th>{lang === 'zh' ? '对比项' : 'Comparison'}</th>
                  <th className="col-y">✦ {lang === 'zh' ? '使用奇迹妙审' : 'With MagicAudit'}</th>
                  <th className="col-n">✕ {lang === 'zh' ? '普通投放方式' : 'Standard Approach'}</th>
                </tr>
              </thead>
              <tbody>
                {t.compare.map((row, i) => (
                  <tr key={i}>
                    <td>{row.label}</td>
                    <td className="col-y"><span className="ck">✦</span> {row.good}</td>
                    <td className="col-n"><span className="cx">✕</span> {row.bad}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </RevealWrapper>
      </div>
    </section>
  );
};

// FAQ Section
const FAQ = ({ lang }) => {
  const t = translations[lang];
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="faq-bg" id="faq">
      <RevealWrapper>
        <div style={{ textAlign: 'center' }}>
          <div className="tag">{lang === 'zh' ? '常见问题' : 'FAQ'}</div>
          <h2 className="s-title">
            <span>{t.faqTitle}</span>
          </h2>
        </div>
      </RevealWrapper>

      <div className="faq-inner">
        {t.faq.map((item, i) => (
          <RevealWrapper key={i} delay={`reveal-delay-${(i % 3) + 1}`}>
            <div className={`faq-item ${openIndex === i ? 'open' : ''}`}>
              <div className="faq-q" onClick={() => setOpenIndex(openIndex === i ? null : i)}>
                {item.q}
                <span className="faq-icon">+</span>
              </div>
              <div className="faq-a">{item.a}</div>
            </div>
          </RevealWrapper>
        ))}
      </div>
    </section>
  );
};

// Pricing Section - API 驱动，参考 front0426 的套餐业务逻辑
const Pricing = ({ lang, onOpenAuth, currentUser, goToDashboard }) => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const t = translations[lang];

  // 获取套餐数据（套餐列表是公开的，不需要认证）
  useEffect(() => {
    const fetchPlans = async () => {
      try {
        setLoading(true);
        const response = await apiRequest(API_ENDPOINTS.PLAN.LIST, {}, false, 'GET');
        const plansData = response?.data || response?.items || [];
        if (plansData.length > 0) {
          setPlans(plansData);
          setError(null);
        } else {
          setError(lang === 'zh' ? '无法获取套餐数据' : 'Unable to retrieve plan data');
        }
      } catch (err) {
        console.error('获取套餐数据失败:', err);
        setError(lang === 'zh' ? '获取套餐失败，请刷新重试' : 'Failed to load plans, please refresh');
      } finally {
        setLoading(false);
      }
    };
    fetchPlans();
  }, [lang]);

  // 生成套餐特性列表 — 与原始LandingPage静态数据和套餐购买页面完全一致
  const getPlanFeatures = (plan) => {
    const totalCalls = plan?.totalCalls ?? 0;
    const isUnlimitedCalls = totalCalls === 0;

    // 1. 如果后端已返回 features 字段，直接使用
    if (plan.features && Array.isArray(plan.features) && plan.features.length > 0) {
      return plan.features;
    }

    // 2. 否则根据套餐字段生成 — 与原始静态plans数据结构对齐
    const features = [];
    const price = Number(plan.price) || 0;

    // 地理定向：$500以下=基础，$500及以上=全球
    if (price < 500) {
      features.push([lang === 'zh' ? '基础地理定向' : 'Basic Geo-Targeting', true]);
    } else {
      features.push([lang === 'zh' ? '全球地理定向' : 'Global Geo-Targeting', true]);
    }

    // UA识别拦截 — 所有套餐都有
    features.push([lang === 'zh' ? 'UA 识别拦截' : 'UA Detection & Block', true]);

    // 访问日志 — 按新配置：1天→30天→90天→180天→365天
    if (isUnlimitedCalls || price >= 3999) {
      features.push([lang === 'zh' ? '访问日志 365 天' : 'Access Logs 365 days', true]);
    } else if (price >= 1999) {
      features.push([lang === 'zh' ? '访问日志 180 天' : 'Access Logs 180 days', true]);
    } else if (price >= 799) {
      features.push([lang === 'zh' ? '访问日志 90 天' : 'Access Logs 90 days', true]);
    } else if (price >= 299) {
      features.push([lang === 'zh' ? '访问日志 30 天' : 'Access Logs 30 days', true]);
    } else if (price > 0) {
      features.push([lang === 'zh' ? '访问日志 30 天' : 'Access Logs 30 days', true]);
    } else {
      features.push([lang === 'zh' ? '访问日志 1 天' : 'Access Logs 1 day', true]);
    }

    // 斗篷数量 + API + 子账号
    if (price >= 3999) {         // 旗舰版 $3999
      features.push([lang === 'zh' ? '无限斗篷数量' : 'Unlimited Cloaks', true]);
      features.push([lang === 'zh' ? 'API 接入' : 'API Access', true]);
      features.push([lang === 'zh' ? '10 个子账号' : '10 Sub-accounts', true]);
    } else if (price >= 1999) {  // 专业版 $1999
      features.push([lang === 'zh' ? '最多 300 个斗篷' : 'Up to 300 Cloaks', true]);
      features.push([lang === 'zh' ? 'API 接入' : 'API Access', true]);
      features.push([lang === 'zh' ? '3 个子账号' : '3 Sub-accounts', true]);
    } else if (price >= 799) {   // 成长版 $799
      features.push([lang === 'zh' ? '最多 100 个斗篷' : 'Up to 100 Cloaks', true]);
      features.push([lang === 'zh' ? 'API 接入' : 'API Access', true]);
      features.push([lang === 'zh' ? '子账号' : 'Sub-accounts', false]);
    } else if (price >= 299) {   // 入门版 $299
      features.push([lang === 'zh' ? '最多 10 个斗篷' : 'Up to 10 Cloaks', true]);
      features.push([lang === 'zh' ? 'API 接入' : 'API Access', false]);
      features.push([lang === 'zh' ? '子账号' : 'Sub-accounts', false]);
    } else {                     // 体验版 $0
      features.push([lang === 'zh' ? '最多 5 个斗篷' : 'Up to 5 Cloaks', true]);
      features.push([lang === 'zh' ? 'API 接入' : 'API Access', false]);
      features.push([lang === 'zh' ? '子账号' : 'Sub-accounts', false]);
    }

    return features;
  };

  // 格式化：排序 + 热门标记 + 多语言名称 + 计算字段
  // 数据字段与 CloakPlans（套餐购买页面）完全对齐
  const getFormattedPlans = () => {
    if (!plans.length) return [];
    // 按金额从小到大排序（与 CloakPricing 一致）
    const sortedPlans = [...plans].sort((a, b) => (Number(a.price) || 0) - (Number(b.price) || 0));
    return sortedPlans.map((plan, index) => {
      const price = Number(plan.price) || 0;
      // 根据价格设置标签：$799=最热销，$1999=高性价比，$3999=大团队
      let badge = '';
      if (price >= 3999) {
        badge = lang === 'zh' ? '大团队' : 'For Teams';
      } else if (price >= 1999) {
        badge = lang === 'zh' ? '高性价比' : 'Best Value';
      } else if (price >= 799) {
        badge = lang === 'zh' ? '最热销' : 'Best Seller';
      }
      // 多语言名称（与 CloakPlans PlanCard 第118/475行一致）
      const displayName = lang === 'zh' ? plan.name : (plan.nameEn || plan.name);
      // 次数字段使用 totalCalls（与 CloakPlans PlanCard 第119/137行一致）
      const totalCalls = plan?.totalCalls ?? 0;
      const isUnlimited = totalCalls === 0;
      const visitsText = isUnlimited
        ? (lang === 'zh' ? '不限' : 'Unlimited')
        : totalCalls.toLocaleString();

      return {
        ...plan,
        name: displayName,
        price: String(plan.price),
        // 访问次数显示 — 与 CloakPlans 一致：totalCalls === 0 显示"不限"
        visits: visitsText,
        // 平均每次费用
        perDay: plan.price > 0 && !isUnlimited && totalCalls > 0
          ? `$${(plan.price / totalCalls).toFixed(4)}`
          : '',
        // 有效期 — 与 CloakPlans PlanCard 第122/136行一致
        valid: plan.randomPeriod
          ? (lang === 'zh' ? '长期有效' : 'Valid long-term')
          : (lang === 'zh' ? `${plan.validityDays} 天有效期` : `Valid ${plan.validityDays} days`),
        features: getPlanFeatures(plan),
        badge: badge,
        popular: !!badge,
      };
    });
  };

  // 购买按钮：已登录跳转仪表盘，未登录打开注册
  const handlePurchase = (plan) => {
    if (currentUser) {
      // 跳转到套餐购买页面，自动打开支付弹窗
      window.location.href = `/dashboard/cloak/pricing?buy=${plan.id}`;
    } else {
      onOpenAuth('register');
    }
  };

  const formattedPlans = getFormattedPlans();

  return (
    <section className="pricing-bg" id="pricing">
      <div className="pricing-inner">
        <RevealWrapper>
          <div style={{ textAlign: 'center', marginBottom: '0' }}>
            <div className="tag">{lang === 'zh' ? '套餐购买' : 'Pricing Plans'}</div>
            <h2 className="s-title">
              <span>{t.pricingTitle}</span>
            </h2>
            <p className="s-desc" style={{ margin: '0 auto' }}>{t.pricingDesc}</p>
          </div>
        </RevealWrapper>

        {loading && (
          <div style={{ textAlign: 'center', padding: '60px 0' }}>
            <div style={{
              display: 'inline-block',
              width: '40px', height: '40px',
              border: '3px solid rgba(99,102,241,0.2)',
              borderTopColor: '#6366f1',
              borderRadius: '50%',
              animation: 'spin 0.8s linear infinite'
            }}></div>
          </div>
        )}

        {error && !loading && (
          <div style={{ textAlign: 'center', padding: '40px 0' }}>
            <div style={{ color: '#ef4444', marginBottom: '12px' }}>{error}</div>
            <button onClick={() => window.location.reload()} className={`btn-plan btn-plan-p`}>
              {lang === 'zh' ? '刷新页面' : 'Refresh'}
            </button>
          </div>
        )}

        {!loading && !error && (
          <div className="pricing-grid">
            {formattedPlans.map((plan, i) => (
              <RevealWrapper key={i} delay={`reveal-delay-${i + 1}`}>
                <div className={`price-card ${plan.popular ? 'featured' : 'gcard'}`}>
                  {plan.badge && (
                    <div className="featured-badge">
                      ⚡  {plan.badge}
                    </div>
                  )}
                  <div className="price-name">{plan.name}</div>
                  <div className="price-amount">
                    <span className="price-curr">$</span>
                    <span className="price-num">{plan.price}</span>
                  </div>
                  <div className="price-per">{plan.valid}</div>
                  <div className="price-avg">{lang === 'zh' ? `平均 ${plan.perDay} / 次` : `Avg ${plan.perDay} / visit`}</div>
                  <div className="price-count">{plan.visits}</div>
                  <div className="price-count-label">{lang === 'zh' ? '真实链接访问次数' : 'Real Link Visits'}</div>
                  <div className="price-divider"></div>
                  <ul className="price-features">
                    {/* TODO: 后续放开子账号功能 */}
                    {plan.features.filter(f => !f[0].includes('子账号')).map((feat, j) => (
                      <li key={j}>
                        <span className={feat[1] ? 'pf-ck' : 'pf-cx'}>{feat[1] ? '✦' : '✕'}</span>
                        <span style={{ color: feat[1] ? 'var(--muted2)' : 'var(--muted)' }}>{feat[0]}</span>
                      </li>
                    ))}
                  </ul>
                  <button
                    className={`btn-plan ${plan.popular ? 'btn-plan-p' : 'btn-plan-g'}`}
                    onClick={() => handlePurchase(plan)}
                  >
                    {t.buyNow}
                  </button>
                </div>
              </RevealWrapper>
            ))}
          </div>
        )}

        <RevealWrapper>
          <div className="trust-row">
            {t.trust.map((item, i) => (
              <div className="trust-badge" key={i}>
                <span className="tb-icon">
                  {i === 0 && '🔒'}
                  {i === 1 && '↩️'}
                  {i === 2 && '💳'}
                  {i === 3 && '🌍'}
                  {i === 4 && '🏆'}
                </span>
                {item}
              </div>
            ))}
          </div>
          <p className="price-note">
            {lang === 'zh' ? '所有套餐均含 14 天无理由退款保障 · 有疑问？' : 'All plans include a 14-day money-back guarantee · Questions? '}
            <a href="#">{lang === 'zh' ? '联系我们' : 'Contact Us'}</a>
          </p>
        </RevealWrapper>
      </div>
    </section>
  );
};

// Final CTA Section
const FinalCTA = ({ lang, onOpenAuth, onOpenSales, currentUser, goToDashboard }) => {
  const t = translations[lang];

  return (
    <section className="cta-bg">
      <div className="cta-glow"></div>
      <RevealWrapper>
        <h2>{t.ctaTitle}</h2>
      </RevealWrapper>
      <RevealWrapper delay="reveal-delay-1">
        <p>{t.ctaDesc}</p>
      </RevealWrapper>
      <RevealWrapper delay="reveal-delay-2">
        <div className="cta-row">
          <button className="btn-hero btn-hero-p" onClick={() => currentUser ? goToDashboard() : onOpenAuth('register')}>
            {t.ctaAction}
          </button>
          <button className="btn-hero btn-hero-g" onClick={onOpenSales}>
            {t.ctaSales}
          </button>
        </div>
      </RevealWrapper>
    </section>
  );
};

// Footer
const Footer = ({ lang }) => {
  const t = translations[lang];

  return (
    <footer>
      <div className="foot-l">
        <div className="foot-brand">
          <img src="/logo.png" alt="MagicAudit" style={{ width: '28px', height: '28px' }} />
          <span>{lang === 'zh' ? '奇迹妙审' : 'MagicAudit'}</span>
        </div>
        <span className="foot-copy">{t.footer}</span>
      </div>
      <nav>
        {t.footerLinks.map((link, i) => (
          <a href="#" key={i}>{link}</a>
        ))}
      </nav>
    </footer>
  );
};

// Floating Bar
const FloatingBar = ({ lang, onOpenAuth, currentUser, goToDashboard }) => {
  const t = translations[lang];
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const sentinelRef = useRef(null);

  useEffect(() => {
    const el = sentinelRef.current;
    if (!el) return;

    // 使用 IntersectionObserver 检测是否滚过哨兵元素
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!dismissed) {
          setVisible(!entry.isIntersecting);
        }
      },
      { threshold: 0 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [dismissed]);

  return (
    <>
      {/* 哨兵元素：位于页面 600px 位置，用于触发 floatBar 显示 */}
      <div ref={sentinelRef} style={{ position: 'absolute', top: '600px', left: 0, width: 0, height: 0 }} />
      
      <div className={`float-bar ${visible ? 'show' : ''}`} style={{ display: dismissed ? 'none' : '' }}>
        <div className="float-bar-text">{t.floatBar}</div>
        <div className="float-bar-actions">
          <button className="btn-primary" style={{ whiteSpace: 'nowrap' }} onClick={() => currentUser ? goToDashboard() : onOpenAuth('register')}>
            {currentUser ? (lang === 'zh' ? '进入管理后台' : 'Dashboard') : (lang === 'zh' ? '免费试用' : 'Free Trial')}
          </button>
          <button className="float-bar-close" onClick={() => { setDismissed(true); setVisible(false); }}>
            ✕
          </button>
        </div>
      </div>
    </>
  );
};

// Social Proof Popup
const SocialPopup = ({ lang }) => {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(0);
  const data = socialPopups;
  const avatarColor = avatarColors[current % avatarColors.length];

  useEffect(() => {
    const showPopup = () => {
      setCurrent(prev => (prev + 1) % data.length);
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    };

    const timer = setTimeout(showPopup, 5000);
    const interval = setInterval(showPopup, 10000);

    return () => {
      clearTimeout(timer);
      clearInterval(interval);
    };
  }, []);

  return (
    <div className={`social-popup ${visible ? 'show' : ''}`}>
      <div className="sp-avatar" style={{ background: avatarColor }}>
        {data[current].email.charAt(0).toUpperCase()}
      </div>
      <div className="sp-text">
        <strong>{data[current].email}</strong>
        <span>{lang === 'zh' ? data[current].zh : data[current].en}</span>
      </div>
      <button className="sp-close" onClick={() => setVisible(false)}>✕</button>
    </div>
  );
};

// Auth Modal
const AuthModal = ({ isOpen, onClose, lang, defaultTab = 'login', onLoginSuccess }) => {
  const t = translations[lang];
  const [activeTab, setActiveTab] = useState(defaultTab);
  const [loginEmail, setLoginEmail] = useState('');
  const [loginPwd, setLoginPwd] = useState('');
  const [regEmail, setRegEmail] = useState('');
  const [regPwd, setRegPwd] = useState('');
  const [regCode, setRegCode] = useState('');
  const [agree, setAgree] = useState(false);
  const [msg, setMsg] = useState({ type: '', text: '' });
  const [codeCountdown, setCodeCountdown] = useState(0);
  const [loading, setLoading] = useState(false);
  const [forgotStep, setForgotStep] = useState(1);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotCode, setForgotCode] = useState('');
  const [forgotPwd, setForgotPwd] = useState('');
  const [forgotPwd2, setForgotPwd2] = useState('');

  // 法律条款模态框
  const [legalModalOpen, setLegalModalOpen] = useState(false);
  const [legalModalTab, setLegalModalTab] = useState('terms');

  const openLegalModal = (tab) => {
    setLegalModalTab(tab);
    setLegalModalOpen(true);
  };

  const closeLegalModal = () => {
    setLegalModalOpen(false);
  };

  useEffect(() => {
    setActiveTab(defaultTab);
    setMsg({ type: '', text: '' });
  }, [isOpen, defaultTab]);

  const validateEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  const validatePwd = (v) => v.length >= 8 && /[a-zA-Z]/.test(v) && /\d/.test(v);

  const handleSendResetCode = async () => {
    if (!validateEmail(forgotEmail)) {
      setMsg({ type: 'error', text: lang === 'zh' ? '请输入正确的邮箱地址' : 'Please enter a valid email' });
      return;
    }
    setLoading(true);
    try {
      const response = await apiRequest(
        '/api/email/send-reset-code',
        { email: forgotEmail, lang: lang === 'zh' ? 'zh_CN' : 'en_US' },
        false,
        'POST'
      );
      if (response.status === 'success') {
        setMsg({ type: 'success', text: lang === 'zh' ? '验证码已发送到您的邮箱' : 'Code sent to your email' });
        setForgotStep(2);
        setCodeCountdown(60);
        const interval = setInterval(() => {
          setCodeCountdown(prev => {
            if (prev <= 1) { clearInterval(interval); return 0; }
            return prev - 1;
          });
        }, 1000);
      } else {
        setMsg({ type: 'error', text: response.message || (lang === 'zh' ? '发送验证码失败' : 'Failed to send code') });
      }
    } catch (error) {
      setMsg({ type: 'error', text: error.message || (lang === 'zh' ? '发送验证码失败' : 'Failed to send code') });
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyResetCode = async () => {
    if (!forgotCode || forgotCode.length !== 6) {
      setMsg({ type: 'error', text: lang === 'zh' ? '请输入6位验证码' : 'Please enter 6-digit code' });
      return;
    }
    setLoading(true);
    try {
      const response = await apiRequest(
        '/api/email/verify-reset-code',
        { email: forgotEmail, code: forgotCode },
        false,
        'POST'
      );
      if (response.status === 'success') {
        setMsg({ type: 'success', text: lang === 'zh' ? '验证码验证成功' : 'Code verified' });
        setForgotStep(3);
      } else {
        setMsg({ type: 'error', text: response.message || (lang === 'zh' ? '验证码错误' : 'Invalid code') });
      }
    } catch (error) {
      setMsg({ type: 'error', text: error.message || (lang === 'zh' ? '验证失败' : 'Verification failed') });
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async () => {
    if (!validatePwd(forgotPwd)) {
      setMsg({ type: 'error', text: lang === 'zh' ? '密码至少8位，需包含字母和数字' : 'Password must be 8+ chars with letters and numbers' });
      return;
    }
    if (forgotPwd !== forgotPwd2) {
      setMsg({ type: 'error', text: lang === 'zh' ? '两次密码不一致' : 'Passwords do not match' });
      return;
    }
    setLoading(true);
    try {
      const response = await apiRequest(
        '/api/user/reset-password',
        { email: forgotEmail, verificationCode: forgotCode, newPassword: forgotPwd },
        false,
        'POST'
      );
      if (response.status === 'success') {
        setMsg({ type: 'success', text: lang === 'zh' ? '密码重置成功，请登录' : 'Password reset! Please login' });
        setTimeout(() => {
          setActiveTab('login');
          setLoginEmail(forgotEmail);
          setForgotStep(1);
          setForgotEmail('');
          setForgotCode('');
          setForgotPwd('');
          setForgotPwd2('');
        }, 2000);
      } else {
        setMsg({ type: 'error', text: response.message || (lang === 'zh' ? '重置失败' : 'Reset failed') });
      }
    } catch (error) {
      setMsg({ type: 'error', text: error.message || (lang === 'zh' ? '重置失败' : 'Reset failed') });
    } finally {
      setLoading(false);
    }
  };

  const handleSendCode = async () => {
    if (!validateEmail(regEmail)) {
      setMsg({ type: 'error', text: lang === 'zh' ? '请输入正确的邮箱地址' : 'Please enter a valid email' });
      return;
    }
    setLoading(true);
    try {
      const response = await apiRequest(
        '/api/user/send-register-code',
        { email: regEmail, lang: lang === 'zh' ? 'zh_CN' : 'en_US' },
        false,
        'POST'
      );
      if (response.status === 'success') {
        setMsg({ type: 'success', text: t.sending });
        setCodeCountdown(60);
        const interval = setInterval(() => {
          setCodeCountdown(prev => {
            if (prev <= 1) {
              clearInterval(interval);
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
      } else {
        setMsg({ type: 'error', text: response.message || (lang === 'zh' ? '发送验证码失败' : 'Failed to send code') });
      }
    } catch (error) {
      console.error('Send code error:', error);
      setMsg({ type: 'error', text: error.message || (lang === 'zh' ? '发送验证码失败，请稍后重试' : 'Failed to send code, please try again') });
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async () => {
    if (!validateEmail(loginEmail) || !loginPwd) {
      setMsg({ type: 'error', text: lang === 'zh' ? '请填写完整的登录信息' : 'Please fill in all login fields' });
      return;
    }
    
    setLoading(true);
    setMsg({ type: '', text: '' });
    
    try {
      const response = await apiRequest(
        API_ENDPOINTS.USER.LOGIN,
        { email: loginEmail, password: loginPwd },
        false,
        'POST'
      );
      
      if (response.status === 'success' || response.code === 200 || response.code === 0) {
        // 兼容Java后端和Python后端的响应格式，提取正确的用户数据和token
        let userData, token;
        if (response.data?.user && response.data?.token) {
          // Java后端格式: { data: { user: {...}, token: "..." } }
          userData = response.data.user;
          token = response.data.token;
        } else if (response.token) {
          // Python后端格式或顶层token
          userData = response.data || { email: loginEmail };
          token = response.token;
        } else {
          userData = response.data || { email: loginEmail };
          token = response.data?.token;
        }
        
        // 保存认证数据
        if (userData && token) {
          saveAuthData(userData, token, false);
        }
        
        // 触发自定义事件，通知Header等组件认证状态已变化
        window.dispatchEvent(new CustomEvent('authStateChanged', { 
          detail: { type: 'login', user: userData } 
        }));
        
        setMsg({ type: 'success', text: t.loginSuccess });
        
        if (onLoginSuccess) {
          onLoginSuccess();
        }
        
        setTimeout(() => {
          onClose();
          // 登录成功，强制刷新页面以更新Header状态
          window.location.href = window.location.pathname + '?t=' + Date.now();
        }, 1000);
      } else {
        setMsg({ type: 'error', text: response.message || (lang === 'zh' ? '登录失败' : 'Login failed') });
      }
    } catch (error) {
      console.error('Login error:', error);
      setMsg({ 
        type: 'error', 
        text: error.message || (lang === 'zh' ? '登录失败，请检查邮箱和密码' : 'Login failed, please check email and password') 
      });
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async () => {
    if (!validateEmail(regEmail) || !validatePwd(regPwd) || regCode.length < 6 || !agree) {
      setMsg({ type: 'error', text: lang === 'zh' ? '请填写完整的注册信息' : 'Please fill in all registration fields' });
      return;
    }
    
    setLoading(true);
    setMsg({ type: '', text: '' });
    
    try {
      const response = await apiRequest(
        API_ENDPOINTS.USER.REGISTER,
        { email: regEmail, password: regPwd, code: regCode },
        false,
        'POST'
      );
      
      if (response.status === 'success' || response.code === 200 || response.code === 0) {
        // 保存认证数据
        if (response.data && response.token) {
          saveAuthData(response.data, response.token, false);
        } else if (response.token) {
          saveAuthData(response.data || { email: regEmail }, response.token, false);
        }
        
        setMsg({ type: 'success', text: t.regSuccess });
        
        if (onLoginSuccess) {
          onLoginSuccess();
        }
        
        setTimeout(() => {
          setActiveTab('login');
          // 清空注册表单
          setRegPwd('');
          setRegCode('');
          setAgree(false);
        }, 1500);
      } else {
        setMsg({ type: 'error', text: response.message || (lang === 'zh' ? '注册失败' : 'Registration failed') });
      }
    } catch (error) {
      console.error('Register error:', error);
      setMsg({ 
        type: 'error', 
        text: error.message || (lang === 'zh' ? '注册失败，请检查验证码是否正确' : 'Registration failed, please check verification code') 
      });
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay show" onClick={onClose}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>✕</button>

        <div className="modal-tabs">
          <button
            className={`modal-tab ${activeTab === 'login' ? 'active' : ''}`}
            onClick={() => setActiveTab('login')}
          >
            {t.loginTitle}
          </button>
          <button
            className={`modal-tab ${activeTab === 'register' ? 'active' : ''}`}
            onClick={() => setActiveTab('register')}
          >
            {t.registerTitle}
          </button>
        </div>

        {activeTab === 'login' && (
          <div id="mFormLogin">
            <div className={`modal-msg ${msg.type}`} style={{ display: msg.text ? 'block' : 'none' }}>
              {msg.text}
            </div>

            <div className="modal-field">
              <label className="modal-label">{t.email}</label>
              <input
                className="modal-input"
                type="email"
                value={loginEmail}
                onChange={e => setLoginEmail(e.target.value)}
                placeholder={lang === 'zh' ? '请输入您的邮箱' : 'Enter your email'}
                autoComplete="email"
              />
            </div>

            <div className="modal-field">
              <label className="modal-label">{t.password}</label>
              <input
                className="modal-input"
                type="password"
                value={loginPwd}
                onChange={e => setLoginPwd(e.target.value)}
                placeholder={lang === 'zh' ? '请输入密码' : 'Enter your password'}
                autoComplete="current-password"
              />
            </div>

            <div className="modal-forgot">
              <a href="#" onClick={(e) => { e.preventDefault(); setActiveTab('forgotPassword'); }}>{t.forgotPassword}</a>
            </div>

            <button className="btn-modal-submit" onClick={handleLogin} disabled={loading}>
              {loading ? (lang === 'zh' ? '登录中...' : 'Logging in...') : t.loginTitle}
            </button>

            <div className="modal-switch">
              {t.noAccount}{' '}
              <a href="#" onClick={() => setActiveTab('register')}>
                {lang === 'zh' ? '立即注册' : 'Register now'}
              </a>
            </div>
          </div>
        )}

        {activeTab === 'register' && (
          <div id="mFormReg">
            <div className={`modal-msg ${msg.type}`} style={{ display: msg.text ? 'block' : 'none' }}>
              {msg.text}
            </div>

            <div className="modal-field">
              <label className="modal-label">{t.email}</label>
              <input
                className="modal-input"
                type="email"
                value={regEmail}
                onChange={e => setRegEmail(e.target.value)}
                placeholder={lang === 'zh' ? '请输入您的邮箱' : 'Enter your email'}
                autoComplete="email"
              />
            </div>

            <div className="modal-field">
              <label className="modal-label">{t.password}</label>
              <input
                className="modal-input"
                type="password"
                value={regPwd}
                onChange={e => setRegPwd(e.target.value)}
                placeholder={lang === 'zh' ? '至少8位，包含字母和数字' : 'At least 8 chars with letters & numbers'}
                autoComplete="new-password"
              />
            </div>

            <div className="modal-field">
              <label className="modal-label">{lang === 'zh' ? '验证码' : 'Verification Code'}</label>
              <div className="modal-code-row">
                <input
                  className="modal-input"
                  type="text"
                  value={regCode}
                  onChange={e => setRegCode(e.target.value)}
                  placeholder={lang === 'zh' ? '请输入6位验证码' : 'Enter 6-digit code'}
                  maxLength={6}
                  inputMode="numeric"
                />
                <button
                  className="btn-send-code"
                  onClick={handleSendCode}
                  disabled={codeCountdown > 0 || loading}
                >
                  {loading ? (lang === 'zh' ? '发送中...' : 'Sending...') : codeCountdown > 0 ? `${codeCountdown}s` : (lang === 'zh' ? '获取验证码' : 'Get Code')}
                </button>
              </div>
            </div>

            <label className="modal-agree">
              <input
                type="checkbox"
                checked={agree}
                onChange={e => setAgree(e.target.checked)}
              />
              <span className="modal-agree-text">
                {lang === 'zh' ? (
                  <>我已阅读并同意 <button type="button" onClick={(e) => { e.preventDefault(); openLegalModal('terms'); }} className="legal-link">服务条款</button> 和 <button type="button" onClick={(e) => { e.preventDefault(); openLegalModal('privacy'); }} className="legal-link">隐私政策</button></>
                ) : (
                  <>I agree to the <button type="button" onClick={(e) => { e.preventDefault(); openLegalModal('terms'); }} className="legal-link">Terms of Service</button> and <button type="button" onClick={(e) => { e.preventDefault(); openLegalModal('privacy'); }} className="legal-link">Privacy Policy</button></>
                )}
              </span>
            </label>

            <button className="btn-modal-submit" onClick={handleRegister} disabled={loading}>
              {loading ? (lang === 'zh' ? '注册中...' : 'Registering...') : t.registerTitle}
            </button>

            <div className="modal-switch">
              {t.haveAccount}{' '}
              <a href="#" onClick={() => setActiveTab('login')}>
                {lang === 'zh' ? '立即登录' : 'Login'}
              </a>
            </div>
          </div>
        )}

        {activeTab === 'forgotPassword' && (
          <div id="mFormForgot">
            <div className={`modal-msg ${msg.type}`} style={{ display: msg.text ? 'block' : 'none' }}>
              {msg.text}
            </div>

            {forgotStep === 1 && (
              <>
                <p style={{ color: '#aaa', marginBottom: '16px', fontSize: '13px' }}>
                  {lang === 'zh' ? '请输入您的注册邮箱，我们将发送验证码' : 'Enter your registered email, we will send a code'}
                </p>
                <div className="modal-field">
                  <label className="modal-label">{t.email}</label>
                  <input
                    className="modal-input"
                    type="email"
                    value={forgotEmail}
                    onChange={e => setForgotEmail(e.target.value)}
                    placeholder={lang === 'zh' ? '请输入邮箱' : 'Enter email'}
                  />
                </div>
                <button className="btn-modal-submit" onClick={handleSendResetCode} disabled={loading}>
                  {loading ? (lang === 'zh' ? '发送中...' : 'Sending...') : (lang === 'zh' ? '发送验证码' : 'Send Code')}
                </button>
              </>
            )}

            {forgotStep === 2 && (
              <>
                <p style={{ color: '#aaa', marginBottom: '16px', fontSize: '13px' }}>
                  {lang === 'zh' ? `验证码已发送至 ${forgotEmail}` : `Code sent to ${forgotEmail}`}
                </p>
                <div className="modal-field">
                  <label className="modal-label">{lang === 'zh' ? '验证码' : 'Verification Code'}</label>
                  <div className="modal-code-row">
                    <input
                      className="modal-input"
                      type="text"
                      value={forgotCode}
                      onChange={e => setForgotCode(e.target.value.replace(/\D/g, ''))}
                      placeholder={lang === 'zh' ? '请输入6位验证码' : 'Enter 6-digit code'}
                      maxLength={6}
                      inputMode="numeric"
                    />
                    <button
                      className="btn-send-code"
                      onClick={handleSendResetCode}
                      disabled={codeCountdown > 0 || loading}
                    >
                      {loading ? (lang === 'zh' ? '发送中...' : 'Sending...') : codeCountdown > 0 ? `${codeCountdown}s` : (lang === 'zh' ? '重发' : 'Resend')}
                    </button>
                  </div>
                </div>
                <button className="btn-modal-submit" onClick={handleVerifyResetCode} disabled={loading}>
                  {loading ? (lang === 'zh' ? '验证中...' : 'Verifying...') : (lang === 'zh' ? '验证' : 'Verify')}
                </button>
              </>
            )}

            {forgotStep === 3 && (
              <>
                <div className="modal-field">
                  <label className="modal-label">{lang === 'zh' ? '新密码' : 'New Password'}</label>
                  <input
                    className="modal-input"
                    type="password"
                    value={forgotPwd}
                    onChange={e => setForgotPwd(e.target.value)}
                    placeholder={lang === 'zh' ? '至少8位，包含字母和数字' : '8+ chars with letters & numbers'}
                    autoComplete="new-password"
                  />
                </div>
                <div className="modal-field">
                  <label className="modal-label">{lang === 'zh' ? '确认密码' : 'Confirm Password'}</label>
                  <input
                    className="modal-input"
                    type="password"
                    value={forgotPwd2}
                    onChange={e => setForgotPwd2(e.target.value)}
                    placeholder={lang === 'zh' ? '再次输入密码' : 'Confirm password'}
                    autoComplete="new-password"
                  />
                </div>
                <button className="btn-modal-submit" onClick={handleResetPassword} disabled={loading}>
                  {loading ? (lang === 'zh' ? '重置中...' : 'Resetting...') : (lang === 'zh' ? '重置密码' : 'Reset Password')}
                </button>
              </>
            )}

            <div className="modal-switch">
              <a href="#" onClick={() => { setActiveTab('login'); setForgotStep(1); }}>
                {lang === 'zh' ? '← 返回登录' : '← Back to login'}
              </a>
            </div>
          </div>
        )}
      </div>
      <LegalModal
        isOpen={legalModalOpen}
        onClose={closeLegalModal}
        initialTab={legalModalTab}
      />
    </div>
  );
};

// Contact Modal - Using framer-motion
const ContactModal = ({ isOpen, onClose, lang }) => {
  const [imgError, setImgError] = useState(false);
  const [copied, setCopied] = useState(false);
  const [copiedContactId, setCopiedContactId] = useState(null);
  const [showQrCode, setShowQrCode] = useState(false);
  const [activeContact, setActiveContact] = useState(null);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(err => {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch (err) {
        console.error('Copy failed:', err);
      }
      document.body.removeChild(textArea);
    });
  };

  const handleToggleQrCode = (e, contact) => {
    e.stopPropagation();
    if (activeContact && activeContact.id === contact.id) {
      setShowQrCode(!showQrCode);
    } else {
      setActiveContact(contact);
      setShowQrCode(true);
      setImgError(false);
    }
  };

  const contacts = [
    { 
      type: 'Telegram', 
      id: '@appcloak9',
      color: '#0088cc',
      link: 'https://t.me/appcloak9'
    },
    { 
      type: lang === 'zh' ? '微信' : 'WeChat', 
      id: 'jp593392476', 
      color: '#07C160',
      qrcode: '/images/wechat-qrcode.png',
      showQrCode: true
    }
  ];

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div 
          className="contact-modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <div className="contact-modal-backdrop" onClick={onClose}></div>
          
          <motion.div 
            className="contact-modal-box"
            initial={{ scale: 0.9, y: 20 }}
            animate={{ scale: 1, y: 0 }}
            exit={{ scale: 0.9, y: 20 }}
          >
            <button className="contact-modal-close" onClick={onClose}>✕</button>
            
            <div className="contact-modal-header">
              <h3>{lang === 'zh' ? '联系我们的精英商务团队' : 'Contact Our Elite Sales Team'}</h3>
              <p>{lang === 'zh' ? '选择下方任一VIP专属通道，立即获得优先响应' : 'Choose any VIP channel below for priority response'}</p>
            </div>
            
            <div className="contact-modal-list">
              {contacts.map((contact, index) => (
                <div 
                  key={index}
                  className="contact-item"
                  onClick={() => {
                    if (contact.link && !contact.showQrCode) {
                      window.open(contact.link, '_blank', 'noopener,noreferrer');
                    } else if (contact.showQrCode) {
                      handleToggleQrCode({ stopPropagation: () => {} }, contact);
                    }
                  }}
                >
                  <div className="contact-icon" style={{ background: contact.color }}>
                    {contact.type === 'Telegram' ? (
                      <svg viewBox="0 0 24 24" fill="white"><path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm.06 8c-.06 0-.126 0-.187.015-.326.047-1.773.593-4.345 2.157-.36.152-.548.33-.563.536-.023.398.29.618.835.861.088.04.205.083.332.128.39.13.946.324 1.228.331.245.012.507-.11.805-.365 2.073-1.743 3.205-2.635 3.395-2.676a.236.236 0 0 1 .241.065.214.214 0 0 1 .006.242c-.077.142-1.168 1.22-1.753 1.789-.184.18-.325.317-.37.362-.102.105-.19.193-.269.273-.473.475-.905.908-.905 1.282 0 .142.062.32.175.521.223.406.452.82.683 1.236.223.4.457.823.723 1.28.033.055.068.107.104.165.212.345.485.527.838.521.146 0 .312-.04.51-.124.024-.04.049-.121.385-1.284.337-1.177.561-1.975.67-2.368.044-.155.087-.41.102-.625a1.446 1.446 0 0 0-.075-.615c-.09-.21-.268-.336-.503-.336z"/></svg>
                    ) : (
                      <svg viewBox="0 0 24 24" fill="white"><path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 0 1 .213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.328.328 0 0 0 .186-.059l2.15-1.338a.591.591 0 0 1 .298-.08c.108 0 .213.02.298.039 1.143.297 2.47.462 3.817.462 5.329 0 9.35-3.09 9.35-7.551 0-4.423-4.682-7.02-10.477-7.02"/></svg>
                    )}
                  </div>
                  <div className="contact-info">
                    <div className="contact-type">{contact.type}</div>
                    <div className="contact-id">{contact.id}</div>
                  </div>
                  <div className="contact-arrow">›</div>
                </div>
              ))}
            </div>
            
            <div className="contact-modal-footer">
              {lang === 'zh' ? '我们的专属商务顾问将在1小时内回复您的咨询' : 'Our dedicated sales team will respond within 1 hour'}
            </div>
          </motion.div>
        </motion.div>
      )}
      
      {/* QR Code Modal */}
      {showQrCode && activeContact && (
        <div className="qr-modal-overlay">
          <div className="qr-modal-backdrop" onClick={() => setShowQrCode(false)}></div>
          <div className="qr-modal-box">
            <button className="qr-modal-close" onClick={() => setShowQrCode(false)}>✕</button>
            {!imgError ? (
              <img 
                src={activeContact.qrcode} 
                alt="WeChat QR Code" 
                className="qr-image"
                onError={() => setImgError(true)}
              />
            ) : (
              <div className="qr-placeholder">
                <p>{lang === 'zh' ? '微信：' + activeContact.id : 'WeChat: ' + activeContact.id}</p>
                <button 
                  className="qr-copy-btn"
                  onClick={() => {
                    copyToClipboard(activeContact.id);
                    setCopiedContactId(activeContact.id);
                  }}
                >
                  {copiedContactId === activeContact.id && copied ? '✓ ' + (lang === 'zh' ? '已复制' : 'Copied') : (lang === 'zh' ? '点击复制' : 'Click to copy')}
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </AnimatePresence>
  );
};

// Main Landing Page Component
const LandingPage = () => {
  const [lang, setLang] = useState('zh');
  const [authModal, setAuthModal] = useState({ isOpen: false, tab: 'login' });
  const [salesModal, setSalesModal] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  // 检查登录状态
  useEffect(() => {
    const checkAuth = () => {
      try {
        const authDataStr = localStorage.getItem('authData');
        if (authDataStr) {
          const authData = JSON.parse(authDataStr);
          if (authData.token && authData.user && authData.user.email) {
            setCurrentUser(authData.user);
            return;
          }
        }
        setCurrentUser(null);
      } catch (e) {
        setCurrentUser(null);
      }
    };
    checkAuth();
    window.addEventListener('authStateChanged', checkAuth);
    return () => window.removeEventListener('authStateChanged', checkAuth);
  }, []);

  // 导航到斗篷管理
  const goToDashboard = () => {
    if (currentUser && (currentUser.role === 'admin' || currentUser.role === 'superadmin')) {
      window.location.href = '/dashboard/admin/dashboard';
    } else {
      window.location.href = '/dashboard';
    }
  };

  const toggleLang = () => setLang(l => l === 'zh' ? 'en' : 'zh');
  const openAuth = (tab) => {
    setAuthModal({ isOpen: true, tab });
  };
  const closeAuth = () => setAuthModal({ ...authModal, isOpen: false });
  const openSales = () => setSalesModal(true);
  const closeSales = () => setSalesModal(false);

  useEffect(() => {
    document.documentElement.lang = lang === 'en' ? 'en' : 'zh-CN';
    document.title = lang === 'zh'
      ? '奇迹妙审 — 广告过审技术领导者'
      : 'MagicAudit — Ad Review Technology Leader';
  }, [lang]);

  return (
    <>
      <div className="noise"></div>
      <div className="aurora">
        <div className="orb orb1"></div>
        <div className="orb orb2"></div>
        <div className="orb orb3"></div>
      </div>

      {/* Announce Bar */}
      <div className="announce">
        {translations[lang].announce}{' '}
        <a href="#" className="announce-pill" onClick={(e) => { e.preventDefault(); currentUser ? goToDashboard() : openAuth('register'); }}>
          {lang === 'zh' ? '立即领取 →' : 'Claim Now →'}
        </a>
      </div>

      <Navigation lang={lang} onOpenAuth={openAuth} onToggleLang={toggleLang} />
      <Hero lang={lang} onOpenAuth={openAuth} currentUser={currentUser} goToDashboard={goToDashboard} />

      <div className="divider"></div>

      <Partners lang={lang} />
      <PhoneCarousel lang={lang} />

      <div className="divider"></div>

      <Architecture lang={lang} />

      <div className="divider"></div>

      <Features lang={lang} />

      <div className="divider"></div>

      <HowItWorks lang={lang} />

      <div className="divider"></div>

      <Compare lang={lang} />

      <div className="divider"></div>

      <Pricing lang={lang} onOpenAuth={openAuth} currentUser={currentUser} goToDashboard={goToDashboard} />

      <FAQ lang={lang} />

      <FinalCTA lang={lang} onOpenAuth={openAuth} onOpenSales={openSales} currentUser={currentUser} goToDashboard={goToDashboard} />

      <Footer lang={lang} />

      <FloatingBar lang={lang} onOpenAuth={openAuth} currentUser={currentUser} goToDashboard={goToDashboard} />
      <SocialPopup lang={lang} />

      <AuthModal
        isOpen={authModal.isOpen}
        onClose={closeAuth}
        lang={lang}
        defaultTab={authModal.tab}
      />
      <ContactModal
        isOpen={salesModal}
        onClose={closeSales}
        lang={lang}
      />
    </>
  );
};

export default LandingPage;
